import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateFileAttributes } from "@/services/api/files";
import type { UpdateFileAttributesRequest } from "@/services/api/files";

interface UseUpdateFileAttributesOptions {
  onSuccess?: () => void;
}

export function useUpdateFileAttributes({
  onSuccess,
}: UseUpdateFileAttributesOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation<
    void,
    Error,
    { fileId: string; data: UpdateFileAttributesRequest }
  >({
    mutationFn: async ({ fileId, data }) => {
      await updateFileAttributes(fileId, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["gallery"] });
      queryClient.invalidateQueries({ queryKey: ["files"] });
      toast.success("Attributes updated", {
        description: "File attributes have been updated successfully.",
      });
      onSuccess?.();
    },
    onError: (error) => {
      toast.error("Failed to update attributes", {
        description:
          error.message || "An error occurred while updating attributes.",
      });
    },
  });
}
